import { getFontFullPath } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { CaptionLineConfig, CaptionStyles, HighlightTypeEnum } from '@/domains/asset';
import { TransitionInEffect } from '@/App/remotion/libs/transitions/types';

const funky: Partial<CaptionStyles> = {
  theme_preset: 'funky',
  pageStyle: {
    color: '#ffffff',
    WebkitTextStrokeWidth: '8px',
    WebkitTextStrokeColor: '#000000',
    paintOrder: 'stroke'
  },
  wordStyle: {
    active: {
      color: '#ffffff'
    },
    inactive: {
      color: '#ffffff'
    },
    highlightType: HighlightTypeEnum.Text
  },
  letterStyle: undefined,
  font_location: getFontFullPath('LuckiestGuy-Regular.ttf'),
  caps: false,
  line_config: CaptionLineConfig.TwoLines,
  font_size: 72,
  transitions: {
    wordIn: TransitionInEffect.Spring
  }
};

export default funky;
